<template>
  <div class="row mb-4">
    <div class="col-lg-7 mx-auto px-4">
      <h1 v-if="section_title != 'null'" class="fs-4 fw-bold mb-3">{{ section_title }}</h1>
    </div>
    <div class="col-lg-7 mx-auto px-lg-4 px-0">
      <div class="card form-card border-0 py-3 px-4 d-flex flex-lg-row flex-column align-items-lg-start align-items-start">
        <img :src="icon" class="mb-auto d-lg-block d-none" alt="" />
        <div class="d-flex align-items-center w-100 d-lg-none d-block">
          <img :src="icon" class="d-lg-none d-block" alt="" />
          <div v-if="hasToggler" class="ms-auto switch-box primary d-lg-none d-flex align-items-center">
            <input @click=";[(visibility = !visibility), (status = !status)]" :checked="visibility" type="checkbox" :id="'switch' + id" />
            <label :for="'switch' + id">Toggle</label>
          </div>
        </div>
        <div class="w-100 px-lg-3">
          <div class="mt-lg-0 mt-2">
            <span class="fw-bold">{{ title }}</span>
            <span class="mx-1 fs-6 text-secondary"></span>
            <small v-if="status == false" class="text-secondary">/ معطل</small>
          </div>
          <div class="text-secondary mb-3 mt-1" v-html="subtitle"></div>
            <slot v-if="visibility"></slot>
        </div>
        <div v-if="hasToggler" class="switch-box primary d-lg-flex align-items-center mb-auto d-none mt-1">
          <input @click=";[(visibility = !visibility), (status = !status)]" :checked="visibility" type="checkbox" :id="'switch' + id" />
          <label :for="'switch' + id">Toggle</label>
        </div>
      </div>
    </div>
      <div class="col-lg-7 mx-auto">
        <slot name="button"></slot>
      </div>
  </div>
</template>
<script>
export default {
  props: ['id', 'section_title', 'title', 'icon', 'status', 'subtitle', 'visibility', 'hasToggler'],
  setup(props) {},
}
</script>